import i18n from "i18next";

const i18nEsMX = i18n.cloneInstance();
i18nEsMX.changeLanguage("es-MX");

export default i18nEsMX;
